import { useQuery } from '@tanstack/react-query'
import { useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { usePackageReqs } from '../../../../api/package-req'
import { getPackageById } from '../../../../services/packages'
import Sticker from '../../Sticker/Sticker'
import { PhotoRequestDetails } from './PhotoRequestDetails'
import { ReturnRequestDetails } from './ReturnRequestDetails'
import { ShrinkRequestDetails } from './ShrinkRequestDetails'
import UniteRequestDetails from './UniteRequestDetails'

export const PackageRequestDetails = ({ itemId }) => {
  const history = useHistory()
  const { data: packageRequestsData } = usePackageReqs({ warehouse: '', onlyPending: false })

  const item = useMemo(() => {
    if (!packageRequestsData) return null
    const allReqs = Object.values(packageRequestsData).flat()
    if (itemId) {
      return allReqs.find(req => req.id === itemId)
    }
    return null
  }, [itemId, packageRequestsData])

  const { data: printingData } = useQuery({
    queryKey: ['package', item?.packageId],
    enabled: !!item?.packageId,
    queryFn: () => getPackageById(item?.packageId),
  })
  const [isPrinting, setIsPrinting] = useState(false)

  const onApprove = async () => {
    setIsPrinting(true)
  }
  const onBack = () => {
    history.goBack()
  }
  if (!item) return null

  if (printingData && isPrinting) {
    return (
      <Sticker
        data={{
          name: printingData.costumer_firstName + ' ' + printingData.costumer_LastName,
          unit: printingData.unit,
          trackingNumberToIsrael: printingData.trackingNumberToIsrael,
          brand: printingData.brand,
          address:
            printingData.shippingAdress_adress +
            ' ' +
            printingData.shippingAdress_apartmentNumber +
            ' ' +
            printingData.shippingAdress_city +
            ' ' +
            printingData.shippingAdress_adress +
            ' ' +
            printingData.shippingAdress_apartmentNumber +
            ' ' +
            printingData.shippingAdress_city +
            ' ' +
            printingData.shippingAdress_postalCode,
        }}
        handleAfterPrint={onBack}
      />
    )
  }
  switch (item.reqType) {
    case 'uniteRequest':
      return <UniteRequestDetails item={item} onApprove={onApprove} onBack={onBack} />
    case 'photoRequest':
      return <PhotoRequestDetails item={item} onApprove={onApprove} onBack={onBack} />
    case 'shrinkRequest':
      return <ShrinkRequestDetails item={item} onApprove={onApprove} onBack={onBack} />
    case 'returnRequest':
      return <ReturnRequestDetails item={item} onApprove={onApprove} onBack={onBack} />
    default:
      history.push('/office-packageRequests')
      return null
  }
}
